import React from 'react'

export default function Preview({question, position, handleSpeech, id, speakingId, cancel}: any) {
  return (
    <>
      <div className='bg-f4f4f4 p-5 mb-7 rounded-3'>
        <div className='d-flex gap-4 align-items-center'>
          <div
            className='bg-gray-700 p-2 w-30px h-30px text-center text-white'
            style={{borderRadius: '6px'}}
          >
            {position}
          </div>
          <p className='text-gray-600 w-100 m-0'>{question.replaceAll("[","{").replaceAll("]","}")}</p>
          {speakingId === id ? (
            <button className='btn btn-icon btn-primary btn-active-primary'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                onClick={(e) => cancel()}
                className='bi bi-soundwave'
                viewBox='0 0 16 16'
              >
                <path
                  fill-rule='evenodd'
                  d='M8.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5zm-2 2a.5.5 0 0 1 .5.5v7a.5.5 0
                  0 1-1 0v-7a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zm-6 1.5A.5.5 0
                  0 1 5 6v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm8 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm-10
                  1A.5.5 0 0 1 3 7v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5zm12 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5z'
                />
              </svg>
            </button>
          ) : (
            <button
              className='btn btn-icon btn-light-primary btn-active-light-primary'
              disabled={speakingId && speakingId !== id}
              onClick={() => handleSpeech(question, id)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-play-fill'
                viewBox='0 0 16 16'
              >
                <path d='m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z' />
              </svg>
            </button>
          )}
        </div>
      </div>
    </>
  )
}
